import { render, staticRenderFns } from "./SalesmenAccounting.vue?vue&type=template&id=2525d1d0&scoped=true&"
import script from "./SalesmenAccounting.vue?vue&type=script&lang=js&"
export * from "./SalesmenAccounting.vue?vue&type=script&lang=js&"
import style0 from "./SalesmenAccounting.vue?vue&type=style&index=0&id=2525d1d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525d1d0",
  null
  
)

export default component.exports